export const toDate = (value?: string | Date | null): Date | null => {
    if (!value) {
        return null;
    }

    if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
    }

    const parsedDate = new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatDate = (date: Date): string => new Intl.DateTimeFormat("en-AU", {
    day: "2-digit",
    month: "short",
    year: "numeric"
}).format(new Date(date));

export const formatDateTime = (date: Date): string => new Intl.DateTimeFormat("en-AU", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit"
}).format(new Date(date));

export const formatMonthDate = (date: Date): string => new Intl.DateTimeFormat("en-AU", {
    month: "short",
    year: "numeric"
}).format(new Date(date));

export const formatRelativeTime = (value: Date | string | null | undefined): string | undefined => {
    const date = toDate(value);

    if (!date) {
        return undefined;
    }

    const minutes = Math.max(0, Math.floor((Date.now() - date.getTime()) / 60000));

    if (minutes < 1) {
        return "just now";
    }

    if (minutes < 60) {
        return `${minutes} min ago`;
    }

    const hours = Math.floor(minutes / 60);

    if (hours < 24) {
        return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    }

    const days = Math.floor(hours / 24);

    return `${days} day${days === 1 ? "" : "s"} ago`;
};
